import axios from "./userInstance"
export default async () => {
  const response = await axios(`/roles/`)
  return response.data
}
